<template>
    <div id="questionnaire" class="page">
        <div class="bg"></div>

        <div class="main-container">
            <div class="header">
                <template v-if="state === 0">
                    <el-button type="primary" v-if="!isEnd" @click.native="submitAnswer(0)">保存
                    </el-button>
                    <el-button type="primary" @click.native="submitAnswer(1)">提交</el-button>
                </template>
                <template v-else>
                    <el-button type="primary" @click.native="submitAnswer(1)">提交</el-button>
                </template>
            </div>
            <div class="questionnaire-container">
                <div class="question-container">

                    <div class="section">
                        <div
                            v-if="hasName('stuBaseInfo')"
                            class="section-item section__title">
                            <div class="question-item__left">
                            </div>
                            <div class="question-item__right">
                                <div>
                                    <span class="title-icon title-icon--base"></span>
                                    学生基本信息
                                </div>
                            </div>
                        </div>
                        <div>
                            <div
                                class="section-item question-item base-info">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint">姓名：</span><span
                                        class="info-text">{{answerList.stuName}}</span>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="section-item question-item base-info">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint">性别：</span><span class="info-text">{{answerList.gender  === 1 ? '男' : '女' }}</span>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="section-item question-item base-info">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint">出生日期：</span><span class="info-text">{{answerList.birthday}}</span>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="section-item question-item base-info">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint">身份证号：</span><span class="info-text">{{answerList.idCard}}</span>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('stature')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="request-hint">*</span>身高：</span>
                                        <el-select v-model="answerList.stature" placeholder="请选择">
                                            <el-option v-for="statureItem in statureList" :label="statureItem.value"
                                                       :value="statureItem.code">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('weight')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="request-hint">*</span>体重：</span>
                                        <el-select v-model="answerList.weight" placeholder="请选择">
                                            <el-option v-for="weightItem in weightList" :label="weightItem.value"
                                                       :value="weightItem.code">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('interests')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="request-hint">*</span>兴趣爱好特长：</span>
                                        <el-input style="width:70%;" type="text" v-model.trim="answerList.interests"
                                                  :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                             <div
                                v-if="hasName('familyJyln')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="request-hint">*</span>家庭教育理念：</span>
                                        <el-input style="width:70%;" type="text" v-model.trim="answerList.familyJyln"
                                                  :maxlength="200">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                             <div
                                v-if="hasName('childJynYdsm')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="request-hint">*</span>孩子近一年来的阅读书目：</span>
                                        <el-input style="width:70%;" type="text" v-model.trim="answerList.childJynYdsm"
                                                  :maxlength="200">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                             <div
                                v-if="hasName('childZxhHdxm')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="request-hint">*</span>孩子最喜欢的亲子活动项目：</span>
                                        <el-input style="width:70%;" type="text" v-model.trim="answerList.childZxhHdxm"
                                                  :maxlength="200">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('nation')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="request-hint">*</span>民族：</span>
                                        <el-select v-model="answerList.nation" placeholder="请选择">
                                            <el-option v-for="nationItem in nationList" :label="nationItem.value"
                                                       :value="nationItem.code">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('nativePlace')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="request-hint">*</span>籍贯：</span>
                                        <el-input style="width:70%;" type="text" v-model.trim="answerList.nativePlace"
                                                  :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('graduateSchool')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <div class="fill-hint"><span class="request-hint">*</span>毕业学校：</div>
                                        <el-input style="width: 70%;" type="text"
                                                  v-model.trim="answerList.graduateSchool" :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('graduateClass')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <div class="fill-hint"><span class="request-hint">*</span>所在班级：</div>
                                        <el-input style="width: 70%;" type="text"
                                                  v-model.trim="answerList.graduateClass" :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div v-if="hasName('homeCity')"
                                 class="question-item question-item--wide">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <div class="fill-hint"><span class="request-hint">*</span>家庭住址：</div>
                                        <el-cascader
                                            size="large"
                                            :options="options"
                                            v-model="answerList.homeAddress">
                                        </el-cascader>
                                        <el-input style="width: 63%;" type="text"
                                                  v-model.trim="answerList.homeAddressDetail" placeholder="请填写详细家庭住址"
                                                  :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div v-if="hasName('birthSite')"
                                 class="question-item question-item--wide">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <div class="fill-hint"><span class="request-hint">*</span>出生地：</div>
                                        <el-cascader
                                            size="large"
                                            :options="options"
                                            v-model="answerList.birthAddress">
                                        </el-cascader>
                                        <el-input style="width: 63%;" type="text"
                                                  v-model.trim="answerList.birthAddressDetail" placeholder="请填写详细出生地"
                                                  :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                            
                            <div
                                v-if="hasName('nodeType')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="request-hint">*</span>户口类型：</span>
                                        <el-select v-model="answerList.nodeType" placeholder="请选择">
                                            <el-option label="非农业户口" :value="0">
                                            </el-option>
                                            <el-option label="农业户口" :value="1">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                             <div
                                v-if="hasName('isTeachAreaStu')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="request-hint">*</span>是否施教区学生：</span>
                                        <el-select v-model="answerList.isTeachAreaStu" placeholder="请选择">
                                            <el-option label="是" :value="1">
                                            </el-option>
                                            <el-option label="否" :value="2">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('childPhoto')"
                                class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="request-hint">*</span>证件照
                                    </div>
                                    <div class="question-item__body">
                                        <div class="item-hint">请上传二寸相片电子稿(建议尺寸:3.5厘米*4.9厘米)</div>
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="false"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.childPhotoPhoto"
                                                  :successCallback="setPhotoType(3)"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('birthCertificateNo')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="request-hint">*</span>出生证编号：</span>
                                        <el-input style="width:70%;" type="text"
                                                  v-model.trim="answerList.birthCertificateNo" :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                            <div v-if="hasName('birthProve')"
                                 class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="request-hint">*</span>出生证（点击查看样例：
                                        <div class="pic-example-container">
                                            <image-previewer tag="richtext" viewclass="pic-example--pic"
                                                             :images="[{src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/chushengzheng.jpg'}]">
                                                <div class="pic-example">
                                                    <div class="pic-example--pic"
                                                         style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/chushengzheng.jpg)"></div>
                                                </div>
                                            </image-previewer>
                                        </div>
                                        ）
                                    </div>
                                    <div class="question-item__body">
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.birthProvePhoto"
                                                  :successCallback="setPhotoType(1)"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>

                            <div v-if="hasName('vaccinateProve')"
                                 class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="request-hint">*</span>预防接种证
                                        （点击查看样例：
                                        <div class="pic-example-container">
                                            <image-previewer tag="richtext" viewclass="pic-example--pic" :images="[{
                                                src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/jiezhognzheng.jpg'
                                                },{
                                                src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/jiezhongjilu1.jpg'
                                                }, {
                                                    src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/jiezhongjilu2.jpg'
                                                }]">
                                                <div class="pic-example">
                                                    <div class="pic-example--pic"
                                                         style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/jiezhognzheng.jpg)"></div>
                                                    <div class="pic-example--pic"
                                                         style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/jiezhongjilu1.jpg)"></div>
                                                    <div class="pic-example--pic"
                                                         style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/jiezhongjilu2.jpg)"></div>
                                                </div>
                                            </image-previewer>
                                        </div>
                                        ）
                                    </div>
                                    <div class="question-item__body">
                                        <div class="item-hint" v-if="schoolId == 569">仅需上传出生接种页关于卡介苗接种的页面</div>
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.vaccinateProvePhoto"
                                                  :successCallback="setPhotoType(2)"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>

                            <div v-if="hasName('isBigBoy')"
                                 class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <el-checkbox v-model="answerList.isBigBoy">
                                            <span style="font-size: 16px;font-weight: bold;color: #565656;">非大孩</span>
                                        </el-checkbox>
                                    </div>
                                    <!-- <div v-show="answerList.isBigBoy" class="question-item__body">
                                        <div class="item-hint">请上传准生证</div>
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.isBigBoyPhoto"
                                                  :successCallback="setPhotoType(10)"
                                        >
                                        </uploader>
                                    </div> -->
                                </div>
                            </div>

                            <div
                                v-if="hasName('isSingleParent')"
                                class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <el-checkbox v-model="answerList.isSingleParent">
                                            <span style="color: #565656;font-size: 16px;font-weight: bold;">
                                                单亲家庭
                                            </span>
                                        </el-checkbox>
                                    </div>
                                    <div v-show="answerList.isSingleParent" class="question-item__body">
                                        <div class="item-hint">请上传单亲证明：离婚证及协议或判决书</div>
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.isSingleParentPhoto"
                                                  :successCallback="setPhotoType(8)"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('isMajorDis')"
                                class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <el-checkbox v-model="answerList.isMajorDis">
                                            <span style="color: #565656;font-size: 16px;font-weight: bold;">
                                                有重大疾病或过敏史
                                            </span>
                                        </el-checkbox>
                                    </div>
                                    <div class="question-item__body" v-show="answerList.isMajorDis">
                                        <el-input type="text" v-model.trim="answerList.majorDisRemark"
                                                  placeholder="请输入重大疾病或过敏源" :maxlength="50">
                                        </el-input>
                                        <div class="item-hint">请上传医院证明</div>
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.isMajorDisPhoto"
                                                  :successCallback="setPhotoType(9)"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('isSingleton')"
                                class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <el-checkbox v-model="answerList.isSingleton">
                                            <span style="color: #565656;font-size: 16px;font-weight: bold;">
                                                独生子女
                                            </span>
                                        </el-checkbox>
                                    </div>
                                </div>
                            </div>
                            <div v-if="hasName('isOnlyChild')" v-show="answerList.isSingleton"
                                 class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <el-checkbox v-model="answerList.isOnlyChild">
                                            <span style="font-size: 16px;font-weight: bold;color: #565656;">独生子女证</span>
                                        </el-checkbox>
                                    </div>
                                    <div v-show="answerList.isOnlyChild" class="question-item__body">
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.isOnlyChildPhoto"
                                                  :successCallback="setPhotoType(4)"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>

                            <div v-if="hasName('isSoldierChild')"
                                 class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <el-checkbox v-model="answerList.isSoldierChild">
                                            <span style="font-size: 16px;font-weight: bold;color: #565656;">军人子女</span>
                                        </el-checkbox>
                                    </div>
                                    <div v-show="answerList.isSoldierChild" class="question-item__body">
                                        <div class="item-hint">请上传军官证</div>
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.isSoldierChildPhoto"
                                                  :successCallback="setPhotoType(5)"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div class="section">
                        <div
                            v-if="hasName('parentsInfo')"
                            class="section-item section__title">
                            <div class="question-item__left">
                            </div>
                            <div class="question-item__right">
                                <div>
                                    <span class="title-icon title-icon--misc"></span>
                                    监护人信息
                                </div>
                            </div>
                        </div>
                        <div v-if="hasName('parentsInfo')">
                            <div style="float: left;width: 49%;">
                                <div class="section-item" v-if="hasName('parentName')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>第一监护人姓名：</span>
                                            <el-input style="width: 70%;"
                                                      v-model.trim="answerList.parentsInfo[0].parentName" type="text"
                                                      :maxlength="50">
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-item" v-if="hasName('nickCode')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>与孩子关系：</span>
                                            <el-select v-model="answerList.parentsInfo[0].nickCode" placeholder="请选择">
                                                <el-option label="爸爸" :value="0">
                                                </el-option>
                                                <el-option label="妈妈" :value="1">
                                                </el-option>
                                                <el-option label="爷爷" :value="2">
                                                </el-option>
                                                <el-option label="奶奶" :value="3">
                                                </el-option>
                                                <el-option label="外公" :value="4">
                                                </el-option>
                                                <el-option label="外婆" :value="5">
                                                </el-option>
                                                <el-option label="家长" :value="6">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-item" v-if="hasName('parentIdCard')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>身份证号：</span>
                                            <el-input style="width: 70%;"
                                                      v-model.trim="answerList.parentsInfo[0].idCard" type="text"
                                                      :maxlength="50">
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-item" v-if="hasName('parentMobile')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>手机：</span>
                                            <el-input style="width: 70%;" v-model.trim="answerList.parentsInfo[0].phone"
                                                      type="text">
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-item" v-if="hasName('parentEducation')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>学历：</span>
                                            <el-select v-model="answerList.parentsInfo[0].eduVal" placeholder="请选择">
                                                <el-option label="无" :value="0">
                                                </el-option>
                                                <el-option label="小学" :value="1">
                                                </el-option>
                                                <el-option label="初中" :value="2">
                                                </el-option>
                                                <el-option label="中专" :value="3">
                                                </el-option>
                                                <el-option label="高职" :value="4">
                                                </el-option>
                                                <el-option label="高中" :value="5">
                                                </el-option>
                                                <el-option label="大学专科" :value="6">
                                                </el-option>
                                                <el-option label="大学本科" :value="7">
                                                </el-option>
                                                <el-option label="研究生/硕士" :value="8">
                                                </el-option>
                                                <el-option label="研究生/博士" :value="9">
                                                </el-option>
                                                <el-option label="研究生/博士后" :value="10">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="section-item" v-if="hasName('dutyType')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>职业类型：</span>
                                            <el-select v-model="answerList.parentsInfo[0].dutyTypeCode"
                                                       placeholder="请选择">
                                                <el-option :label="teachItem.value" :value="teachItem.code"
                                                           v-for="teachItem in dutyTypeList">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="section-item" v-if="hasName('parentWorkPlace')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>工作单位：</span>
                                            <el-input style="width: 70%;"
                                                      v-model.trim="answerList.parentsInfo[0].workPlace" type="text"
                                                      :maxlength="50">
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-item" v-if="hasName('duty')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>职务：</span>
                                            <el-input style="width: 70%;" v-model.trim="answerList.parentsInfo[0].duty"
                                                      type="text" :maxlength="50">
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="hasName('residenceAddress')">
                                    <div class="section-item">
                                        <div class="question-item__right">
                                            <div class="question-item__title">
                                                <span class="fill-hint"><span class="red-star">*</span>户籍所在地：</span>
                                                <el-cascader
                                                    size="large"
                                                    :options="options"
                                                    v-model="answerList.parentsInfo[0].residence">
                                                </el-cascader>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="section-item">
                                        <div class="question-item__right">
                                            <div class="question-item__title">
                                                <span class="fill-hint"></span>
                                                <el-input style="width: 70%;"
                                                          v-model.trim="answerList.parentsInfo[0].residenceAddress"
                                                          placeholder="请填写详细地址"
                                                          type="text" :maxlength="50">
                                                </el-input>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div style="float: left;width: 49%;">
                                <div class="section-item" v-if="hasName('parentName')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>第二监护人姓名：</span>
                                            <el-input style="width: 70%;"
                                                      v-model.trim="answerList.parentsInfo[1].parentName" type="text"
                                                      :maxlength="50">
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-item" v-if="hasName('nickCode')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>与孩子关系：</span>
                                            <el-select v-model="answerList.parentsInfo[1].nickCode" placeholder="请选择">
                                                <el-option label="爸爸" :value="0">
                                                </el-option>
                                                <el-option label="妈妈" :value="1">
                                                </el-option>
                                                <el-option label="爷爷" :value="2">
                                                </el-option>
                                                <el-option label="奶奶" :value="3">
                                                </el-option>
                                                <el-option label="外公" :value="4">
                                                </el-option>
                                                <el-option label="外婆" :value="5">
                                                </el-option>
                                                <el-option label="家长" :value="6">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-item" v-if="hasName('parentIdCard')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>身份证号：</span>
                                            <el-input style="width: 70%;"
                                                      v-model.trim="answerList.parentsInfo[1].idCard" type="text"
                                                      :maxlength="50">
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-item" v-if="hasName('parentMobile')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>手机：</span>
                                            <el-input style="width: 70%;" v-model.trim="answerList.parentsInfo[1].phone"
                                                      type="text">
                                            </el-input>
                                        </div>
                                    </div>
                                </div>

                                <div class="section-item" v-if="hasName('parentEducation')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>学历：</span>
                                            <el-select v-model="answerList.parentsInfo[1].eduVal" placeholder="请选择">
                                                <el-option label="无" :value="0">
                                                </el-option>
                                                <el-option label="小学" :value="1">
                                                </el-option>
                                                <el-option label="初中" :value="2">
                                                </el-option>
                                                <el-option label="中专" :value="3">
                                                </el-option>
                                                <el-option label="高职" :value="4">
                                                </el-option>
                                                <el-option label="高中" :value="5">
                                                </el-option>
                                                <el-option label="大学专科" :value="6">
                                                </el-option>
                                                <el-option label="大学本科" :value="7">
                                                </el-option>
                                                <el-option label="研究生/硕士" :value="8">
                                                </el-option>
                                                <el-option label="研究生/博士" :value="9">
                                                </el-option>
                                                <el-option label="研究生/博士后" :value="10">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-item" v-if="hasName('dutyType')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>职业类型：</span>
                                            <el-select v-model="answerList.parentsInfo[1].dutyTypeCode"
                                                       placeholder="请选择">
                                                <el-option :label="teachItem.value" :value="teachItem.code"
                                                           v-for="teachItem in dutyTypeList">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-item" v-if="hasName('parentWorkPlace')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>工作单位：</span>
                                            <el-input style="width: 70%;"
                                                      v-model.trim="answerList.parentsInfo[1].workPlace" type="text"
                                                      :maxlength="50">
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-item" v-if="hasName('duty')">
                                    <div class="question-item__right">
                                        <div class="question-item__title">
                                            <span class="fill-hint"><span class="red-star">*</span>职务：</span>
                                            <el-input style="width: 70%;" v-model.trim="answerList.parentsInfo[1].duty"
                                                      type="text" :maxlength="50">
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="hasName('residenceAddress')">
                                    <div class="section-item">
                                        <div class="question-item__right">
                                            <div class="question-item__title">
                                                <span class="fill-hint"><span class="red-star">*</span>户籍所在地：</span>
                                                <el-cascader
                                                    size="large"
                                                    :options="options"
                                                    v-model="answerList.parentsInfo[1].residence">
                                                </el-cascader>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="section-item">
                                        <div class="question-item__right">
                                            <div class="question-item__title">
                                                <span class="fill-hint"></span>
                                                <el-input style="width: 70%;"
                                                          v-model.trim="answerList.parentsInfo[1].residenceAddress"
                                                          placeholder="请填写详细地址"
                                                          type="text" :maxlength="50">
                                                </el-input>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div class="section" v-if="hasName('healthTravelCode')">
                        <div
                            class="section-item section__title">
                            <div class="question-item__left">
                            </div>
                            <div class="question-item__right">
                                <div>
                                    <span class="title-icon title-icon--misc"></span>
                                    健康码及行程码
                                </div>
                            </div>
                        </div>
                        <div>
                            <div
                                class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="request-hint">*</span>请提供父亲和母亲的健康码及动态行程码（点击查看样例：
                                        <div class="pic-example-container">
                                            <image-previewer tag="richtext" viewclass="pic-example--pic"
                                                             :images="[{src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/jkm.png'},
                                                             {src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/xcm.png'}]">
                                                <div class="pic-example">
                                                    <div class="pic-example--pic"
                                                         style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/jkm.png)"></div>
                                                </div>
                                                <div class="pic-example">
                                                    <div class="pic-example--pic"
                                                         style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/xcm.png)"></div>
                                                </div>
                                            </image-previewer>
                                        </div>
                                        ）
                                    </div>
                                    <div class="question-item__body">
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.healthTravelPics"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="section">
                        <div
                            class="section-item section__title">
                            <div class="question-item__left">
                            </div>
                            <div class="question-item__right">
                                <div>
                                    <span class="title-icon title-icon--misc"></span>
                                    户籍信息
                                </div>
                            </div>
                        </div>
                        <div class="address-container">
                            <div
                                v-if="hasName('houseHolder')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>户主姓名：</span>
                                        <el-input style="width: 70%;" type="text"
                                                  v-model.trim="answerList.stuPropertyList[0].houseHolder"
                                                  :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('holderRelation')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>与孩子关系：</span>
                                        <el-select v-model="answerList.stuPropertyList[0].holderRelation"
                                                   placeholder="请选择">
                                            <el-option label="父子/父女" :value="1">
                                            </el-option>
                                            <el-option label="母子/母女" :value="2">
                                            </el-option>
                                            <el-option label="祖孙" :value="3">
                                            </el-option>
                                            <el-option label="其它" :value="4">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('settleTime')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>学生落户时间：</span>
                                        <el-date-picker
                                            v-model="answerList.stuPropertyList[0].settleTime"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </div>
                                </div>
                            </div>

                            <div v-if="hasName('accAddress')"
                                 class="question-item question-item--wide">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>户籍地址：</span>
                                        <template v-if="hasName('accAddressFill')">
                                            <el-cascader
                                                size="large"
                                                :options="options"
                                                v-model="answerList.stuPropertyList[0].accAddressFillCode">
                                            </el-cascader>
                                            <el-input style="margin-left: 149px;margin-top: 20px;width: 70%;"
                                                      type="text"
                                                      v-model.trim="answerList.stuPropertyList[0].accAddress"
                                                      :maxlength="50" placeholder="请填写详细地址">
                                            </el-input>
                                        </template>
                                        <template v-else>
                                            <el-select
                                                @change="getSubTeachArea(answerList.stuPropertyList[0].accAddress, 'subTeachAreaList1', false ,true)"
                                                v-model="answerList.stuPropertyList[0].accAddress" placeholder="请选择">
                                                <el-option :label="teachItem.value" :value="teachItem.code"
                                                           v-for="teachItem in teachAreaList">
                                                </el-option>
                                            </el-select>
                                            <el-select
                                                v-if="answerList.stuPropertyList[0].accAddress != 0 && subTeachAreaList1.length !== 0"
                                                v-model="answerList.stuPropertyList[0].accDetAddress" placeholder="请选择">
                                                <el-option :label="teachItem.value" :value="teachItem.code"
                                                           v-for="teachItem in subTeachAreaList1">
                                                </el-option>
                                            </el-select>

                                            <el-input v-show="answerList.stuPropertyList[0].accAddress == 9999"
                                                      style="width:  63%" type="text"
                                                      v-model.trim="answerList.stuPropertyList[0].accDetSupplement"
                                                      :maxlength="50" placeholder="与户口本保持一致">
                                            </el-input>
                                            <span v-show="answerList.stuPropertyList[0].accAddress != 9999"
                                                  style="width: 217px" type="text">
                                                <el-input style="width: 63%" type="text"
                                                          v-model.trim="accDepartHelper[0]" :maxlength="50"
                                                          placeholder="请输入户籍地址详情（X幢X单元X室）"
                                                         >
                                                </el-input>
                                            </span>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('addressPhoto')"
                                class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__body">
                                        <div class="item-hint">
                                            <template v-if="schoolId == 569">请上传本户口全部有内容的户口页</template>
                                            <template v-else>请上传户口本户主页、父亲页、母亲页、孩子页</template>
                                            （点击查看样例：
                                            <div class="pic-example-container">
                                                <image-previewer tag="richtext" viewclass="pic-example--pic" :images="[{
                                                src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/hukouben1.jpg'
                                                }, {
                                                    src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/hukouben2.jpg'
                                                }]">
                                                    <div class="pic-example">
                                                        <div class="pic-example--pic"
                                                             style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/hukouben1.jpg)"></div>
                                                        <div class="pic-example--pic"
                                                             style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/hukouben2.jpg)"></div>
                                                    </div>
                                                </image-previewer>
                                            </div>
                                            ）
                                        </div>
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.addressPhotoPhoto"
                                                  :successCallback="setPhotoType(6)"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('otherCertificate')"
                                class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__title question-item__title--general">
                                        <span class="fill-hint" style="width: 12em;">非本户籍地址户口证明：</span>
                                    </div>
                                    <div class="question-item__body">
                                        <div class="item-hint">
                                            <template>如监护人一方户口不在房产内，还需要增加结婚证或离婚证和离婚协议、外地工作证明/农业户口证明/军人证明等</template>
                                        </div>
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.otherCertificatePhoto"
                                                  :successCallback="setPhotoType(12)"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="section">
                        <div
                            class="section-item section__title">
                            <div class="question-item__left">
                            </div>
                            <div class="question-item__right">
                                <div>
                                    <span class="title-icon title-icon--misc"></span>
                                    产权信息
                                </div>
                            </div>
                        </div>
                        <div class="address-container">
                            <div
                                v-if="hasName('propertyType')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>产权类型：</span>
                                        <el-select v-model="answerList.stuPropertyList[0].propertyType"
                                                   placeholder="请选择">
                                            <el-option :label="propertyTypeItem.value" :value="propertyTypeItem.code"
                                                       v-for="propertyTypeItem in propertyTypeList">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="109 == answerList.stuPropertyList[0].propertyType && hasName('propertyTypeRemark')"
                                class="question-item question-item--wide">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>备注：</span>
                                        <div class="textarea-container">
                                            <el-input
                                                type="textarea"
                                                :autosize="{ minRows: 3, maxRows: 4}"
                                                placeholder="请填写产权类型备注"
                                                :maxlength="200"
                                                v-model="answerList.stuPropertyList[0].propertyTypeRemark">
                                            </el-input>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('propertyNo')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>产权证（租赁证）号：</span>
                                        <el-input type="text" style="width: 70%;"
                                                  v-model.trim="answerList.stuPropertyList[0].propertyNo"
                                                  :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('propertyHolder')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>所有产权人姓名：</span>
                                        <el-input style="width: 70%;" type="text"
                                                  v-model.trim="answerList.stuPropertyList[0].propertyHolder"
                                                  :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('withChildRelation')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>产权人与孩子关系：</span>
                                        <el-select style="width: 150px;"
                                                   v-model="answerList.stuPropertyList[0].withChildRelation"
                                                   placeholder="请选择">
                                            <el-option label="父母" :value="1">
                                            </el-option>
                                            <el-option label="祖父母" :value="2">
                                            </el-option>
                                            <el-option label="外祖父母" :value="3">
                                            </el-option>
                                            <el-option label="其他" :value="4">
                                            </el-option>
                                        </el-select>
                                        <el-input style="width: 150px;"
                                                  v-if="answerList.stuPropertyList[0].withChildRelation == 4"
                                                  type="text"
                                                  v-model.trim="answerList.stuPropertyList[0].withChildRelationDes"
                                                  placeholder="请填写与孩子关系"
                                                  :maxlength="20">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('propertyRelation')"
                                class="question-item question-item--wide">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>产权关系：</span>
                                        <el-select v-model="answerList.stuPropertyList[0].propertyRelation"
                                                   placeholder="请选择">
                                            <el-option :label="propertyRelationItem.value"
                                                       :value="propertyRelationItem.code"
                                                       v-for="propertyRelationItem in propertyRelationList">
                                            </el-option>
                                        </el-select>
                                        <span
                                            v-if="2 == answerList.stuPropertyList[0].propertyRelation">（面审当天需要带无房证明）</span>
                                        <div
                                            style="padding-left: 7em;font-weight: normal;"
                                            v-if="hasName('propertyNaProve') && 2 == answerList.stuPropertyList[0].propertyRelation"
                                            class="question-item question-item--pic">
                                            <div class="question-item__right">
                                                <div class="question-item__body">
                                                    <div class="item-hint">请上传无房证明
                                                        （请上传《我的南京》中房产信息的截图）
                                                    </div>
                                                    <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue"
                                                              pathPrefix="zhaoshengbaomingxiaoxue" moduleCode="247"
                                                              prefixPath="schoolSignup"
                                                              :multiple="true"
                                                              :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                              showMode="image"
                                                              showResult="image"
                                                              v-model="answerList.propertyNaProvePhoto"
                                                              :successCallback="setPhotoType(11)"
                                                    >
                                                    </uploader>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="8 == answerList.stuPropertyList[0].propertyRelation && hasName('propertyRatio')"
                                class="question-item question-item--wide">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>产权占比：</span>
                                        <div class="textarea-container">
                                            <br/>
                                            <div class="ratio-item" v-for="ratioItem in propertyRatioList">
                                                <div class="ratio-item__part">
                                                    <span>产权人: </span>
                                                    <span><el-input placeholder="产权人" :maxlength="50"
                                                                    v-model="ratioItem.name"></el-input></span>
                                                </div>
                                                <div class="ratio-item__part">
                                                    <span>与孩子关系: </span>
                                                    <span><el-input placeholder="关系" :maxlength="50"
                                                                    v-model="ratioItem.relation"></el-input></span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('propertyAddress') && answerList.stuPropertyList[0].propertyRelation != 6"
                                class="question-item question-item--wide">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>产权地址：</span>
                                        <el-input v-if="hasName('propertyAddressFill')" style="width: 70%;" type="text"
                                                  v-model.trim="answerList.stuPropertyList[0].propertyAddress"
                                                  :maxlength="50" :placeholder="`与产权证保持一致`">
                                        </el-input>
                                        <template v-else>
                                            <el-select
                                                @change="getSubTeachArea(answerList.stuPropertyList[0].propertyAddress,  'subTeachAreaList2', false ,false)"
                                                v-model="answerList.stuPropertyList[0].propertyAddress"
                                                placeholder="请选择">
                                                <el-option :label="teachItem.value" :value="teachItem.code"
                                                           v-for="teachItem in teachAreaList">
                                                </el-option>
                                            </el-select>
                                            <el-select
                                                v-if="answerList.stuPropertyList[0].propertyAddress != 0 && subTeachAreaList2.length !== 0"
                                                v-model="answerList.stuPropertyList[0].propertyDetAddress"
                                                placeholder="请选择">
                                                <el-option :label="teachItem.value" :value="teachItem.code"
                                                           v-for="teachItem in subTeachAreaList2">
                                                </el-option>
                                            </el-select>
                                            <el-input style="width: 217px" type="text"
                                                      v-model.trim="answerList.stuPropertyList[0].propertyDetSupplement"
                                                      :maxlength="50" placeholder="请填写详细产权地址">
                                            </el-input>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <div v-if="hasName('propertyTime') && answerList.stuPropertyList[0].propertyRelation != 6"
                                 class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>产权登记时间：</span>

                                        <el-date-picker
                                            v-model="answerList.stuPropertyList[0].propertyTime"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('propertyArea') && answerList.stuPropertyList[0].propertyRelation != 6"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>建筑面积：</span>
                                        <el-input type="text" style="width: 70%;"
                                                  v-model.trim="answerList.stuPropertyList[0].propertyArea"
                                                  :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('qiuNo') && answerList.stuPropertyList[0].propertyRelation != 6"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>丘权号：</span>
                                        <el-input type="text" style="width: 70%;"
                                                  v-model.trim="answerList.stuPropertyList[0].qiuNo" :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('sectionNo') && answerList.stuPropertyList[0].propertyRelation != 6"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>路段号：</span>
                                        <el-input type="text" style="width: 70%;"
                                                  v-model.trim="answerList.stuPropertyList[0].sectionNo"
                                                  :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="hasName('propertyPhoto') && answerList.stuPropertyList[0].propertyRelation != 6"
                                class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__body">
                                        <div class="item-hint">请上传房产证
                                            （点击查看样例：
                                            <div class="pic-example-container">
                                                <image-previewer tag="richtext" viewclass="pic-example--pic" :images="[{
                                                src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/chanquanzheng_xin_1.jpg'
                                                }, {
                                                    src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/chanquanzheng_xin_2.jpg'
                                                }, {
                                                    src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/chanquanzheng_xin_3.jpg'
                                                }]">
                                                    <div class="pic-example">
                                                        <div class="pic-example--pic"
                                                             style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/chanquanzheng_xin_1.jpg)"></div>
                                                        <div class="pic-example--pic"
                                                             style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/chanquanzheng_xin_2.jpg)"></div>
                                                        <div class="pic-example--pic"
                                                             style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/chanquanzheng_xin_3.jpg)"></div>
                                                    </div>
                                                </image-previewer>
                                            </div>
                                            ）
                                        </div>
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.propertyPhotoPhoto"
                                                  :successCallback="setPhotoType(7)"
                                        >
                                        </uploader>
                                    </div>
                                </div>

                            </div>
                            <div
                                v-if="hasName('houseDetailsPhotos') && answerList.stuPropertyList[0].propertyRelation != 6"
                                class="question-item question-item--pic">
                                <div class="question-item__right">
                                    <div class="question-item__body">
                                        <div class="item-hint"><span class="red-star">*</span>请分别附上父亲和母亲在“我的南京”中的各三张截图“我的”、“房产交易信息”、“房屋信息”
                                            （点击查看样例：
                                            <div class="pic-example-container">
                                                <image-previewer tag="richtext" viewclass="pic-example--pic" :images="[{
                                                src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/fangwu1.png'
                                                }, {
                                                    src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/fangwu2.jpg'
                                                }, {
                                                    src: 'https://cdnfile-10043692.file.myqcloud.com/schoolSignup/fangwu3.png'
                                                }]">
                                                    <div class="pic-example">
                                                        <div class="pic-example--pic"
                                                             style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/fangwu1.png)"></div>
                                                        <div class="pic-example--pic"
                                                             style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/fangwu2.jpg)"></div>
                                                        <div class="pic-example--pic"
                                                             style="background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/fangwu3.png)"></div>
                                                    </div>
                                                </image-previewer>
                                            </div>
                                            ）
                                        </div>
                                        <uploader :schoolId="schoolId" module="zhaoshengbaomingxiaoxue" pathPrefix="zhaoshengbaomingxiaoxue"
                                                  moduleCode="247"
                                                  prefixPath="schoolSignup"
                                                  :multiple="true"
                                                  :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                                  showMode="image"
                                                  showResult="image"
                                                  v-model="answerList.houseDetailsPics"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('isLive')"
                                class="question-item">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint">
                                            <el-checkbox v-model="answerList.stuPropertyList[0].isLive" :true-label="1"
                                                         :false-label="2">
                                                <span class="checkbox-text">实际居住</span>
                                            </el-checkbox>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('actualAddress')"
                                v-show="answerList.stuPropertyList[0].isLive == 2"
                                class="question-item question-item--wide">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>实际居住地址：</span>
                                        <el-cascader
                                            size="large"
                                            :options="options"
                                            v-model="answerList.actualAddressCode">
                                        </el-cascader>

                                    </div>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"></span>
                                        <el-input type="text" placeholder="请输入详细地址" style="width: 70%;"
                                                  v-model.trim="answerList.actualAddress" :maxlength="50">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('liveMembers')"
                                v-show="answerList.stuPropertyList[0].isLive == 1"
                                class="question-item question-item--wide">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint"><span class="red-star">*</span>实际居住人员：</span>
                                        <div class="textarea-container">
                                            <el-input
                                                type="textarea"
                                                :autosize="{ minRows: 3, maxRows: 4}"
                                                placeholder="请填写实际居住人员"
                                                :maxlength="200"
                                                v-model="answerList.stuPropertyList[0].liveMembers">
                                            </el-input>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('propertyRemark')"
                                class="question-item question-item--wide">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <span class="fill-hint">备注：</span>
                                        <div class="textarea-container">
                                            <el-input
                                                type="textarea"
                                                :autosize="{ minRows: 3, maxRows: 4}"
                                                :placeholder="placeholder||'请填写产权备注'"
                                                :maxlength="500"
                                                v-model="answerList.stuPropertyList[0].propertyRemark">
                                            </el-input>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="hasName('confirmHint')"
                                class="question-item question-item--wide">
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <div style="color: #565656;font-size: 16px;font-weight: bold;">
                                            <div class="confirm-part"><span class="red-star">*</span>家长确认：</div>
                                            <div class="confirm-part confirm-part--text" v-for="item in confirmText">
                                                {{item}}
                                            </div>
                                            <el-checkbox style="margin-left: 9px;" v-model="isConfirm">
                                                <span
                                                    style="color: #565656;font-size: 16px;font-weight: bold;">我已了解</span>
                                            </el-checkbox>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Uploader from '@/components/Uploader/WebUploader';
    import {mapGetters} from 'vuex';
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
    import {regionData, CodeToText} from '@/utils/element-china-area-data'
    import baseMixin from '@/mixins/baseMixin';

    import BackTool from '@/components/BackTool';
    import DefaultPage from '@/components/DefaultPage';
    import {
        getFieldSetInfo,
        getStuInfoByToken,
        insertStuInfo,
        updateStuInfo,
        getNotice,
        additionalStuInfo
    } from '@/api/primary/outer';

    import {
        findDicsByCode,
        findSchoolDicsByCode,
    } from '@/api/common';
    import {queryById} from '@/api/primary/outer';

    import moment from 'moment';

    export default {
        name: "questionnaire",
        components: {
            BackTool,
            DefaultPage,
            ImagePreviewer,
            Uploader
        },
        mixins: [baseMixin],
        computed: {
            areaName() {
                let areaName = '';
                if (this.orgAreaName) {
                    const areaArray = this.orgAreaName.split(' ');
                    areaName = areaArray[areaArray.length - 1];
                }
                return areaName;
            },
             ...mapGetters(['schoolInfo'])
        },
        data: function () {
            return {
                isSubmited: false,
                idCardType: this.$route.query.cardType,
                schoolId: this.$route.query.schoolId,
                noticeId: this.$route.query.noticeId,
                loginPhone: this.$route.query.loginPhone,
                orgAreaName: this.$route.query.orgAreaName,
                options: regionData,
                basePath: global.BasePath,
                userId: this.$route.query.userId,
                id: this.$route.query.id,
                updateId: null,
                fieldNameList: [],
                isConfirm: false,
                confirmText: '',

                accDepartHelper: ['', '', ''],

                propertyRatioList: [{
                    name: '',
                    relation: ''
                }, {
                    name: '',
                    relation: ''
                }, {
                    name: '',
                    relation: ''
                }, {
                    name: '',
                    relation: ''
                }, {
                    name: '',
                    relation: ''
                }],

                answerList: {
                    stuName: '',
                    idCard: '',
                    birthday: '',
                    gender: '--',
                    nation: '1001',
                    weight: '',
                    stature: '',
                    birthCertificateNo: '',
                    nodeType: '',
                    isTeachAreaStu:1,
                    graduateSchool: '',
                    graduateClass: '',
                    actualAddress: '',
                    actualAddressCode: ['320000', '320100', '320102'],
                    nativePlace: '',
                    homeAddress: ['320000', '320100', '320102'],
                    homeAddressDetail: '',
                    birthAddress: ['320000', '320100', '320102'],
                    birthAddressDetail: '',
                    birthProve: true,
                    vaccinateProve: true,
                    isOnlyChild: false,
                    isSoldierChild: false,
                    isBigBoy: false,
                    birthProvePhoto: [],
                    vaccinateProvePhoto: [],
                    isOnlyChildPhoto: [],
                    isSoldierChildPhoto: [],
                    isBigBoyPhoto: [],
                    addressPhoto: true,
                    childPhoto: true,
                    propertyPhoto: true,
                    addressPhotoPhoto: [],
                    childPhotoPhoto: [],
                    propertyPhotoPhoto: [],
                    isSingleParentPhoto: [],
                    isMajorDisPhoto: [],
                    propertyNaProvePhoto: [],
                    otherCertificatePhoto: [],

                    healthTravelPics: [],
                    houseDetailsPics: [],

                    isSingleParent: false,
                    isMajorDis: false,
                    isSingleton: false,
                    majorDisRemark: '',

                    parentsInfo: [{
                        parentType: 1,
                        parentName: '',
                        phone: '',
                        idCard: '',
                        eduVal: 0,
                        workPlace: '',
                        duty: '',
                        dutyTypeCode: '',
                        dutyTypeName: '',
                        residenceAddress: '',
                        nickCode: '',
                        residence: ['320000', '320100', '320102'],

                    }, {
                        parentType: 2,
                        parentName: '',
                        phone: '',
                        idCard: '',
                        eduVal: 0,
                        workPlace: '',
                        duty: '',
                        dutyTypeCode: '',
                        dutyTypeName: '',
                        residenceAddress: '',
                        nickCode: '',
                        residence: ['320000', '320100', '320102'],

                    }],

                    stuPropertyList: [{
                        houseHolder: '',
                        accAddress: '',
                        accDetAddress: '',
                        accDetSupplement: '',
                        holderRelation: 1,
                        isLive: 2,
                        propertyAddress: '',
                        propertyDetAddress: '',
                        propertyAddressDetail: '',
                        propertyDetSupplement: '',
                        propertyHolder: '',
                        propertyNo: '',
                        propertyRelation: '',
                        propertyRatio: '',
                        propertyTime: '',
                        propertyArea: '',
                        qiuNo: '',
                        sectionNo: '',
                        liveMembers: '',
                        propertyType: '',
                        schoolDistrict: 1,
                        settleTime: '',
                        propertyTypeRemark: '',
                        propertyRemark: '',
                        accAddressFillCode: ['320000', '320100', '320102'],
                        withChildRelation: 1,
                        withChildRelationDes: ''
                    }]
                },
                nationList: [],
                propertyTypeList: [],
                propertyRelationList: [],
                teachAreaList: [],
                subTeachAreaList1: [],
                subTeachAreaList2: [],
                dutyTypeList: [],
                statureList: [],
                weightList: [],

                state: 0,

                isAdd: false,
                isEnd: false,
                fromEdit: this.$route.query.fromEdit,
                placeholder:'',
                areaCode:''
            }
        },
        created() {           
            setTimeout(() => {
                queryById({
                    id: this.schoolId
                })
                    .then(res => res.data)
                    .then(data => {
                        const areaCode = data.data.areaCode;
                        this.areaCode=data.data.areaCode;
                        let areaCodeArray = [];
                        if (areaCode) {
                            areaCodeArray = [`${areaCode.slice(0, 2)}0000`, `${areaCode.slice(0, 4)}00`, `${areaCode.slice(0, 6)}`]
                        } else {
                            areaCodeArray = ['320000', '320100', this.areaCode||'320102'];
                        }
                         if(this.areaCode){
                            this.answerList.actualAddressCode[2]=this.areaCode
                            this.answerList.homeAddress[2]=this.areaCode
                            this.answerList.birthAddress[2]=this.areaCode  
                            this.answerList.parentsInfo[0].residence[2]=this.areaCode
                            this.answerList.parentsInfo[1].residence[2]=this.areaCode
                            this.answerList.stuPropertyList[0].accAddressFillCode[2]=this.areaCode
                        }
                        console.log('areaCodeArray', areaCodeArray)
                        this.answerList.actualAddressCode = JSON.parse(JSON.stringify(areaCodeArray));
                        this.answerList.homeAddress = JSON.parse(JSON.stringify(areaCodeArray));
                        this.answerList.birthAddress = JSON.parse(JSON.stringify(areaCodeArray));
                        this.answerList.parentsInfo[0].residence = JSON.parse(JSON.stringify(areaCodeArray));
                        this.answerList.parentsInfo[1].residence = JSON.parse(JSON.stringify(areaCodeArray));
                        this.answerList.stuPropertyList[0].accAddressFillCode = JSON.parse(JSON.stringify(areaCodeArray));
                         getNotice({
                noticeId: this.noticeId
            })
                .then(res => res.data)
                .then(data => {
                    if (data.result) {
                        this.isEnd = data.data.noticeState === 3;
                        findSchoolDicsByCode({
                            schoolId: this.schoolId,
                            dicCode: data.data.enrolType === 1 ? 'primaryTeachAreas' : 'middleTeachAreas'
                        })
                            .then(res => res.data)
                            .then(data => {
                                // data.data.push({
                                //     code: '9999',
                                //     value: '其他'
                                // });

                                this.teachAreaList = data.data;
                            });

                        findSchoolDicsByCode({
                            schoolId: this.schoolId,
                            dicCode: 'stature'
                        })
                            .then(res => res.data)
                            .then(data => {
                                this.statureList = data.data;
                                if (data.data.length !== 0 && !this.answerList.stature) {
                                    this.answerList.stature = data.data[0].code;
                                }
                            });

                        findSchoolDicsByCode({
                            schoolId: this.schoolId,
                            dicCode: 'weight'
                        })
                            .then(res => res.data)
                            .then(data => {
                                this.weightList = data.data;
                                if (data.data.length !== 0 && !this.answerList.weight) {
                                    this.answerList.weight = data.data[0].code;
                                }
                            });
                    }
                });
            findDicsByCode({
                dicCode: 'national'
            })
                .then(res => res.data)
                .then(data => {
                    this.nationList = data.data;
                });
                  findSchoolDicsByCode({
                            schoolId: this.schoolId,
                            dicCode: 'jzbztsy'
                        })
                            .then(res => res.data)
                            .then(data => {
                                this.placeholder =data.data[0]?data.data[0].value:'';
                            });
            findDicsByCode({
                dicCode: 'dutyType'
            })
                .then(res => res.data)
                .then(data => {
                    this.dutyTypeList = data.data;
                });


            getFieldSetInfo({
                schoolId: this.schoolId,
                yearNo: moment().format('YYYY')
            })
                .then(res => res.data)
                .then(data => {
                    const fieldNameList = [];
                    const propertyRelationList = [];
                    const propertyTypeList = [];

                    data.data.forEach(item => {
                        fieldNameList.push(item.fieldName);
                        if (/^propertyRelationOption\d+$/.test(item.fieldName)) {
                            propertyRelationList.push({
                                code: parseInt(item.fieldRemark),
                                value: item.fieldDesc
                            });
                        } else if (/^propertyTypeOption\d+$/.test(item.fieldName)) {
                            propertyTypeList.push({
                                code: parseInt(item.fieldRemark),
                                value: item.fieldDesc
                            });
                        }

                    });
                    this.fieldNameList = fieldNameList;
                    this.propertyRelationList = propertyRelationList;
                    this.propertyTypeList = propertyTypeList;

                    if (this.hasName('confirmHint')) {
                        const remark = data.data.find(item => item.fieldName === 'confirmHint').fieldRemark;
                        if (remark) {
                            this.confirmText = remark.split('\n');
                        }
                    }

                    getStuInfoByToken({
                        token: sessionStorage.getItem('outerToken')
                    })
                        .then(res => res.data)
                        .then(data => {
                            if (this.fromEdit != 1) {
                                if (
                                    data.data.state !== 0
                                ) {
                                    this.$router.replace({
                                        path: 'outerQuestionnaireDetail',
                                        query: {
                                            schoolId: this.schoolId,
                                            noticeId: this.noticeId,
                                            userId: this.userId,
                                            id: this.id,
                                            loginPhone: this.loginPhone
                                        }
                                    });
                                }
                            }
                            this.state = data.data.state;
                            this.initData(data.data);
                            this.answerList.stuName = this.$route.query.stuName;
                            this.answerList.gender = data.data.gender;
                            this.answerList.idCard = data.data.idCard;
                            this.answerList.birthday = data.data.birthday;
                            this.answerList.isBigBoy = data.data.isBigBoy==1;
                            console.log(this.answerList)
                            if (data.data.id !== 0) {
                                this.isAdd = false;
                                this.updateId = data.data.id;
                            } else {
                                this.isAdd = true;
                            }

                        });
                })
                    })
            }, 500);

        },
        filters: {
            brTrim(value) {
                return value.replace('\n', '<br />');
            }
        },
        methods: {
            trimNonNumber(helperIndex) {
                this.$set(this.accDepartHelper, helperIndex, `${this.accDepartHelper[helperIndex]}`.trim().replace(/[^\d]/g, ''));
            },
            getSubTeachArea(addressObj, prop, isClear = true, isClearDepart = false) {
                if (isClearDepart) {
                    this.answerList.stuPropertyList[0].accDetSupplement = '';
                    this.accDepartHelper = ['', '', ''];
                }

                findSchoolDicsByCode({
                    schoolId: this.schoolId,
                    dicCode: addressObj
                })
                    .then(res => res.data)
                    .then(data => {

                        this[prop] = data.data;
                        if (isClear) {
                            if (prop === 'subTeachAreaList1') {
                                if (data.data.length !== 0) {
                                    this.answerList.stuPropertyList[0].accDetAddress = data.data[0].code;
                                } else {
                                    this.answerList.stuPropertyList[0].accDetAddress = '';
                                }
                            } else {
                                if (data.data.length !== 0) {
                                    this.answerList.stuPropertyList[0].propertyDetAddress = data.data[0].code;
                                } else {
                                    this.answerList.stuPropertyList[0].propertyDetAddress = '';
                                }
                            }
                        }
                    });
            },
            hasName(name) {
                return this.fieldNameList.indexOf(name) !== -1;
            },
            deletePic(picList, picIndex) {
                picList.splice(picIndex, 1);
            },
            radioChangeHandler(questionItem, optionItem) {
                questionItem.optionList.forEach(item => {
                    if (item.id !== optionItem.id) {
                        item.isSelected = 0;
                    }
                })
            },

            setPhotoType(type) {
                return (data) => {
                    data.photoUrl = data.fileUrl;
                    data.itemType = type;
                }
            },
            submitAnswer(state) {
                this.checkValid()
                    .then(isValid => {
                        if (isValid) {
                            if (!this.hasName('confirmHint') || this.isConfirm) {
                                const args = this.packData();
                                args.state = state;
                                args.isDataComplete = 1;
                                args.isBigBoy=this.answerList.isBigBoy?1:2
                                this.isSubmited = true;
                                new Promise((resolve, reject) => {
                                    if (this.isAdd) {
                                        if (this.isEnd) {
                                            args.noticeId = Number.parseInt(this.noticeId);
                                            args.schoolId = Number.parseInt(this.schoolId);
                                            args.idCardType = Number.parseInt(this.idCardType);
                                            additionalStuInfo({
                                                token: sessionStorage.getItem('outerToken'),
                                                studentJson: JSON.stringify(args)
                                            })
                                                .then(res => res.data)
                                                .then(data => {
                                                    if (data.result) {
                                                        resolve()
                                                    } else {
                                                        reject(data.msg);
                                                    }
                                                })
                                        } else {
                                            insertStuInfo({
                                                token: sessionStorage.getItem('outerToken'),
                                                studentJson: JSON.stringify(args)
                                            })
                                                .then(res => res.data)
                                                .then(data => {
                                                    if (data.result) {
                                                        resolve()
                                                    } else {
                                                        reject(data.msg);
                                                    }
                                                })
                                        }

                                    } else {
                                        args.id = this.updateId;
                                        updateStuInfo({
                                            token: sessionStorage.getItem('outerToken'),
                                            studentJson: JSON.stringify(args)
                                        })
                                            .then(res => res.data)
                                            .then(data => {
                                                if (data.result) {
                                                    resolve();
                                                } else {
                                                    reject(data.msg);
                                                }
                                            })
                                    }
                                })
                                    .then(() => {
                                        if (state == 0) {
                                            this.$message({
                                                message: '资料仅保存、尚未提交，请及时提交',
                                                type: 'success'
                                            });
                                        } else {
                                            this.$message({
                                                message: this.isAdd ? '保存成功' : '修改成功',
                                                type: 'success'
                                            });
                                        }

                                        setTimeout(() => {
                                            this.$router.replace({
                                                path: 'outerQuestionnaireDetail',
                                                query: {
                                                    schoolId: this.schoolId,
                                                    noticeId: this.noticeId,
                                                    userId: this.userId,
                                                    id: this.id,
                                                    loginPhone: this.loginPhone
                                                }
                                            });
                                        }, 1000);
                                    })
                                    .catch(msg => {
                                        this.$message.error(msg);
                                    })
                            } else {
                                this.$message.error('请确认内容是否属实!');
                            }
                        }
                    })
            },
            checkValid() {
                let isValid = true;
                let errorMsg = '';
                let errorItem = '';
                this.fieldNameList.forEach(item => {
                    if (isValid) {
                        if ([
                            'birthProve',
                            'vaccinateProve',
                            'isSoldierChild',
                            // 'isBigBoy',
                            'childPhoto',
                            'addressPhoto',
                        ].indexOf(item) !== -1) {
                            if (this.answerList[item] && this.answerList[`${item}Photo`].length === 0) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if(item == 'isOnlyChild' && this.answerList.isSingleton) {
                            if (this.answerList[item] && this.answerList[`${item}Photo`].length === 0) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if (item == 'propertyPhoto' && this.answerList.stuPropertyList[0].propertyRelation != 6) {
                            if (this.answerList[item] && this.answerList[`${item}Photo`].length === 0) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if (item === 'homeCity') {
                            if (this.answerList['homeAddress'].some(item => !item) || !this.answerList['homeAddressDetail']) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if (item === 'birthSite') {
                            if (this.answerList['birthAddress'].some(item => !item) || !this.answerList['birthAddressDetail']) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if ([
                            'parentName',
                            'parentMobile',
                            'parentIdCard',
                            'parentEducation',
                            'parentWorkPlace',
                            'duty',
                            'dutyType',
                            'residenceAddress',
                            'nickCode'
                        ].indexOf(item) !== -1) {
                            const fatherInfo = this.answerList.parentsInfo[0];
                            const motherInfo = this.answerList.parentsInfo[1];

                            if (this.answerList.isSingleParent) {
                                if (fatherInfo.parentName === '') {
                                    isValid = false;
                                    errorMsg = '第一监护人姓名不能为空';
                                    errorItem = item;
                                }
                            } else {
                                if (fatherInfo.parentName === '' || motherInfo.parentName === '') {
                                    isValid = false;
                                    errorMsg = '监护人姓名不能为空';
                                    errorItem = item;
                                }
                            }
                            if (isValid) {
                                if (fatherInfo.parentName) {
                                    switch (item) {
                                        case 'parentMobile':
                                            const phoneReg = /^[1][345789][0-9]{9}$/;
                                            if (fatherInfo.phone === '') {
                                                isValid = false;
                                                errorMsg = '第一监护人手机号不能为空';
                                                errorItem = item;
                                            } else if (!phoneReg.test(fatherInfo.phone)) {
                                                isValid = false;
                                                errorMsg = '第一监护人手机号格式不正确';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'nickCode':
                                            if (fatherInfo.nickCode === '') {
                                                isValid = false;
                                                errorMsg = '第一监护人与孩子关系不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'parentIdCard':
                                            if (fatherInfo.idCard === '') {
                                                isValid = false;
                                                errorMsg = '第一监护人身份证号不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'parentWorkPlace':
                                            if (fatherInfo.workPlace === '') {
                                                isValid = false;
                                                errorMsg = '第一监护人工作单位不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'duty':
                                            if (fatherInfo.duty === '') {
                                                isValid = false;
                                                errorMsg = '第一监护人职务不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'dutyType':
                                            if (fatherInfo.dutyTypeCode === '') {
                                                isValid = false;
                                                errorMsg = '第一监护人职业类型不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'residenceAddress':
                                            if (fatherInfo.residenceAddress === '') {
                                                isValid = false;
                                                errorMsg = '第一监护人户籍所在地不能为空';
                                                errorItem = item;
                                            } else if (!fatherInfo.residence || fatherInfo.residence.length === 0) {
                                                isValid = false;
                                                errorMsg = '第一监护人户籍所在地不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                    }
                                }
                                if (motherInfo.parentName) {
                                    switch (item) {
                                        case 'parentMobile':
                                            const phoneReg = /^[1][345789][0-9]{9}$/;
                                            if (motherInfo.phone === '') {
                                                isValid = false;
                                                errorMsg = '第二监护人手机号不能为空';
                                                errorItem = item;
                                            } else if (!phoneReg.test(motherInfo.phone)) {
                                                isValid = false;
                                                errorMsg = '第二监护人手机号格式不正确';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'nickCode':
                                            if (motherInfo.nickCode === '') {
                                                isValid = false;
                                                errorMsg = '第二监护人与孩子关系不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'parentIdCard':
                                            if (motherInfo.idCard === '') {
                                                isValid = false;
                                                errorMsg = '第二监护人身份证号不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'parentWorkPlace':
                                            if (motherInfo.workPlace === '') {
                                                isValid = false;
                                                errorMsg = '第二监护人工作单位不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'duty':
                                            if (motherInfo.duty === '') {
                                                isValid = false;
                                                errorMsg = '第二监护人职务不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'dutyType':
                                            if (motherInfo.dutyTypeCode === '') {
                                                isValid = false;
                                                errorMsg = '第二监护人职业类型不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                        case 'residenceAddress':
                                            if (motherInfo.residenceAddress === '') {
                                                isValid = false;
                                                errorMsg = '第二监护人户籍所在地不能为空';
                                                errorItem = item;
                                            } else if (!motherInfo.residence || motherInfo.residence.length === 0) {
                                                isValid = false;
                                                errorMsg = '第二监护人户籍所在地不能为空';
                                                errorItem = item;
                                            }
                                            break;
                                    }
                                }
                            }
                        } else if ([
                            'nation',
                            'graduateSchool',
                            'graduateClass',
                            'nativePlace',
                            'interests',
                            'familyJyln',
                            'childJynYdsm',
                            'childZxhHdxm',
                            'birthCertificateNo',
                        ].indexOf(item) !== -1) {
                            if (!this.answerList[item]) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if ([
                            'stature',
                            'weight'
                        ].indexOf(item) !== -1) {
                            if (!this.answerList[item]) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if ([
                            'houseHolder',
                            'holderRelation',
                            'settleTime',
                            'propertyType',
                            'propertyNo',
                            'propertyHolder',
                            'propertyRelation',
                        ].indexOf(item) !== -1) {
                            if (!this.answerList.stuPropertyList[0][item]) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if ([
                            'propertyTime',
                            'propertyArea',
                            'qiuNo',
                            'sectionNo'
                        ].indexOf(item) !== -1 && this.answerList.stuPropertyList[0].propertyRelation != 6) {
                            if (!this.answerList.stuPropertyList[0][item]) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if (item === 'isMajorDis' && this.answerList.isMajorDis) {
                            if (this.answerList.majorDisRemark === '') {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                            // if (this.answerList[`isMajorDisPhoto`].length === 0) {
                            //     isValid = false;
                            //     errorMsg = '';
                            //     errorItem = item;
                            // }
                        } else if (item === 'accAddress') {
                            if (this.answerList.stuPropertyList[0].accAddress === '') {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                            if (this.hasName('accAddressFill') && (!this.answerList.stuPropertyList[0].accAddressFillCode || this.answerList.stuPropertyList[0].accAddressFillCode.length === 0)) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                            // if (!this.hasName('accAddressFill') && this.answerList.stuPropertyList[0].accAddress != 9999 && this.accDepartHelper[2] == '') {
                            //     isValid = false;
                            //     errorMsg = '请填写室号';
                            // }
                        } else if (this.answerList.stuPropertyList[0].propertyRelation != 6 && item === 'propertyAddress') {
                            if (this.answerList.stuPropertyList[0].propertyAddress === '') {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if (item === 'propertyRatio') {
                            if (8 == this.answerList.stuPropertyList[0].propertyRelation &&
                                this.propertyRatioList.every(item => item.name.trim() === '' || item.relation.trim() === '')) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if (item === 'propertyNaProve') {
                            if (2 == this.answerList.stuPropertyList[0].propertyRelation) {
                                if (this.answerList[`${item}Photo`].length === 0) {
                                    isValid = false;
                                    errorMsg = '';
                                    errorItem = item;
                                }
                            }
                        } else if (item === 'actualAddress') {
                            if (this.answerList.stuPropertyList[0].isLive == 1 &&
                                this.answerList.actualAddress.trim() === '' && (!this.answerList.actualAddressCode || this.answerList.actualAddressCode.length === 0)) {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if (item === 'liveMembers') {
                            if (this.answerList.stuPropertyList[0].isLive == 1 && this.answerList.stuPropertyList[0].liveMembers.trim() === '') {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if (item === 'propertyTypeRemark') {
                            if (109 == this.answerList.stuPropertyList[0].propertyType &&
                                this.answerList.stuPropertyList[0].propertyTypeRemark.trim() === '') {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if (item === 'otherCertificate') {
                            // if (this.answerList[`${item}Photo`].length === 0) {
                            //     isValid = false;
                            //     errorMsg = '';
                            //     errorItem = item;
                            // }
                        } else if (item === 'nodeType') {
                            if (this.answerList.nodeType === '') {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        } else if (item === 'isTeachAreaStu') {
                            if (this.answerList.isTeachAreaStu === '') {
                                isValid = false;
                                errorMsg = '';
                                errorItem = item;
                            }
                        }else if (this.answerList.stuPropertyList[0].propertyRelation != 6 && item === 'houseDetailsPhotos' && this.answerList.houseDetailsPics.length === 0) {
                            isValid = false;
                            errorMsg = '请上传房屋信息照片';
                            errorItem = item;
                        } else if (item === 'healthTravelCode' && this.answerList.healthTravelPics.length === 0) {
                            isValid = false;
                            errorMsg = '请上传父母健康码及行程码';
                            errorItem = item;
                        } else if (item === 'withChildRelation') {
                            if (!this.answerList.stuPropertyList[0].withChildRelation) {
                                isValid = false;
                                errorMsg = '请选择产权人与孩子关系';
                                errorItem = item;
                            } else if (this.answerList.stuPropertyList[0].withChildRelation == 4 && this.answerList.stuPropertyList[0].withChildRelationDes.trim() === '') {
                                isValid = false;
                                errorMsg = '请填写产权人与孩子关系';
                                errorItem = item;
                            }
                        }
                        if (!isValid) {
                            console.log(item);
                        }
                    }
                });
                if (!isValid) {
                    const itemMapping = {
                        birthProve: '出生证',
                        vaccinateProve: '预防接种证',
                        isOnlyChild: '独生子女证',
                        isSoldierChild: '军人子女证明',
                        // isBigBoy: '准生证',
                        childPhoto: '证件照',
                        addressPhoto: '户口本照片',
                        propertyPhoto: '房产证照片',
                        otherCertificate: '非本户籍地址户口证明',
                        isSingleParent: '单亲家庭证明',
                        homeCity: '家庭住址',
                        homeAddress: '省市区',
                        homeAddressDetail: '详细地址',
                        birthSite: '出生地址',
                        birthAddress: '出生地省市区',
                        birthAddressDetail: '出生地详细地址',
                        nation: '民族',
                        graduateSchool: '毕业学校',
                        graduateClass: '所在班级',
                        actualAddress: '实际居住地址',
                        nativePlace: '籍贯',
                        stature: '身高',
                        weight: '体重',
                        houseHolder: '户主姓名',
                        holderRelation: '户主与孩子关系',
                        settleTime: '学生落户时间',
                        propertyType: '产权类型',
                        propertyNo: '产权证/租赁证号',
                        propertyHolder: '所有产权人姓名',
                        propertyRelation: '产权人与孩子关系',
                        propertyTime: '产权登记时间',
                        propertyArea: '建筑面积',
                        qiuNo: '丘权号',
                        sectionNo: '路段号',
                        liveMembers: '实际居住人员',
                        isMajorDis: '大病或过敏史证明',
                        accAddress: '户籍地址',
                        propertyAddress: '产权地址',
                        interests: '兴趣爱好特长',
                        familyJyln: '家庭教育理念',
                        childJynYdsm: '孩子近一年来的阅读书目',
                        childZxhHdxm: '孩子最喜欢的亲子活动项目',
                        propertyRatio: '产权比例',
                        propertyNaProve: '无房证明',
                        propertyTypeRemark: '产权类型备注',
                        birthCertificateNo: '出生证编号',
                        nodeType: '户口类型',
                        isTeachAreaStu:'是否施教区学生'
                    };

                    this.$message({
                        message: errorMsg || `请${errorItem.indexOf('Photo') === -1 && errorItem.indexOf('propertyNaProve') === -1 ? '填写' : '上传'}${itemMapping[errorItem]}`,
                        type: 'error'
                    });
                }

                if (isValid && this.hasName('accAddress') &&
                    !this.hasName('accAddressFill') &&
                    this.hasName('propertyAddress') &&
                    !this.hasName('propertyAddressFill')) {
                    if (this.answerList.stuPropertyList[0].propertyRelation != 6 && this.answerList.stuPropertyList[0].accAddress != this.answerList.stuPropertyList[0].propertyAddress) {
                        return this.$confirm('户籍地址与产权地址的施教区不一致，是否确认？')
                            .then(_ => {
                                return Promise.resolve(isValid);
                            })
                            .catch(_ => {
                                return Promise.resolve(false);
                            });

                    } else {
                        return Promise.resolve(isValid);

                    }
                } else {
                    return Promise.resolve(isValid);
                }
            },
            initData(sourceData) {
                const answerList = {};

                this.fieldNameList.forEach(item => {
                    if ([
                        'stuName',
                        'birthday',
                        'idCard',
                        'graduateSchool',
                        'graduateClass',
                        'actualAddress',
                        'nativePlace',
                        'interests',
                        'familyJyln',
                        'childJynYdsm',
                        'childZxhHdxm',
                        'birthCertificateNo',
                        'nodeType',
                        'isTeachAreaStu'
                    ].indexOf(item) !== -1) {
                        answerList[item] = sourceData[item] === null || sourceData[item] === undefined ? '' : sourceData[item];
                    } else if ([
                        'isOnlyChild',
                        'isSoldierChild',
                        // 'isBigBoy'
                    ].indexOf(item) !== -1) {
                        answerList[item] = sourceData[item] === 1;
                    } else if ([
                        'childPhoto',
                        'addressPhoto',
                        'propertyPhoto'
                    ].indexOf(item) !== -1) {
                        answerList[item] = true;
                    } else if (item === 'homeCity') {
                        answerList.homeAddress = [sourceData.homeProvCode || '320000', sourceData.homeCityCode || '320100', sourceData.homeCountyCode || '320102'];
                        answerList.homeAddressDetail = sourceData.homeAddress || '';
                    } else if (item === 'birthSite') {
                        answerList.birthAddress = [sourceData.birthProvCode || '320000', sourceData.birthCityCode || '320100', sourceData.birthCountyCode || '320102'];
                        answerList.birthAddressDetail = sourceData.birthAddress || '';
                    } else if (item === 'nation') {
                        if (sourceData.nationCode) {
                            answerList.nation = sourceData.nationCode;
                        }
                    } else if (item === 'isMajorDis') {
                        answerList.isMajorDis = sourceData.isMajorDis === 1;
                        answerList.majorDisRemark = sourceData.majorDisRemark || '';
                    } else if (item === 'isSingleParent') {
                        answerList.isSingleParent = sourceData.isSingleParent === 1;
                    } else if (item === 'isSingleton') {
                        answerList.isSingleton = sourceData.isSingleton === 1;
                    } else if ([
                        'stature',
                        'weight'
                    ].indexOf(item) !== -1) {
                        if (sourceData[item] !== null) {
                            answerList[item] = sourceData[`${item}Code`] ? sourceData[`${item}Code`].toString() : '';
                        }
                    } else if (item === 'healthTravelCode') {
                        if (sourceData.healthTravelPics) {
                            answerList.healthTravelPics = JSON.parse(sourceData.healthTravelPics);
                        }
                    }
                });
                if (this.hasName('actualAddress') && sourceData.stuPropertyList && sourceData.stuPropertyList[0] && sourceData.stuPropertyList[0].isLive == 2) {
                    answerList.actualAddressCode = [sourceData.actualProvCode, sourceData.actualCityCode, sourceData.actualCountyCode]
                }
                if (sourceData.father) {
                    sourceData.father.residence = [sourceData.father.resProvCode, sourceData.father.resCityCode, sourceData.father.resCountyCode];
                }
                if (sourceData.mather) {
                    sourceData.mather.residence = [sourceData.mather.resProvCode, sourceData.mather.resCityCode, sourceData.mather.resCountyCode];
                }

                answerList.parentsInfo = [
                    sourceData.father || {
                        parentType: 1,
                        parentName: '',
                        phone: '',
                        idCard: '',
                        eduVal: 0,
                        workPlace: '',
                        duty: '',
                        dutyTypeCode: '',
                        dutyTypeName: '',
                        nickCode: '',
                        residence: ['320000', '320100', this.schoolInfo.areaCode||'320102'],
                    },
                    sourceData.mather || {
                        parentType: 2,
                        parentName: '',
                        phone: '',
                        idCard: '',
                        eduVal: 0,
                        workPlace: '',
                        duty: '',
                        dutyTypeCode: '',
                        dutyTypeName: '',
                        nickCode: '',
                        residence: ['320000', '320100', this.schoolInfo.areaCode||'320102'],
                    }
                ];
                if (sourceData.stuPropertyList && sourceData.stuPropertyList.length !== 0) {
                    const stuPropertyList = sourceData.stuPropertyList;
                    stuPropertyList[0].propertyTypeRemark = sourceData.stuPropertyList[0].propertyTypeRemark || '';
                    if (stuPropertyList[0].propertyAddressCode) {
                        stuPropertyList[0].propertyAddress = stuPropertyList[0].propertyAddressCode;
                        if (stuPropertyList[0].propertyAddressCode != 0) {
                            this.getSubTeachArea(stuPropertyList[0].propertyAddressCode, 'subTeachAreaList2', false);
                            stuPropertyList[0].propertyDetAddress = stuPropertyList[0].propertyDetAddressCode;
                        } else {
                            stuPropertyList[0].propertyDetAddress = stuPropertyList[0].propertyDetAddress;
                        }
                    }
                    if (stuPropertyList[0].accAddressCode) {
                        stuPropertyList[0].accAddress = stuPropertyList[0].accAddressCode;
                        if (stuPropertyList[0].accAddressCode != 0) {
                            this.getSubTeachArea(stuPropertyList[0].accAddressCode, 'subTeachAreaList1', false);
                            stuPropertyList[0].accDetAddress = stuPropertyList[0].accDetAddressCode;
                        } else {
                            stuPropertyList[0].accDetAddress = stuPropertyList[0].accDetAddress
                        }
                    }
                    if (stuPropertyList[0].propertyTypeCode !== null) {
                        stuPropertyList[0].propertyType = parseInt(stuPropertyList[0].propertyTypeCode);
                    }
                    if (stuPropertyList[0].accDetHelpStr) {
                        this.accDepartHelper = stuPropertyList[0].accDetHelpStr.split(',');
                    }
                    if (this.hasName('accAddressFill')) {
                        stuPropertyList[0].accAddressFillCode = [stuPropertyList[0].accProvCode, stuPropertyList[0].accCityCode, stuPropertyList[0].accCountyCode]
                    }

                    answerList.stuPropertyList = stuPropertyList;
                }

                if (sourceData.stuBasicPicList) {
                    const stuBasicPic = sourceData.stuBasicPicList;

                    const propMapping = [
                        '',
                        'birthProvePhoto',
                        'vaccinateProvePhoto',
                        'childPhotoPhoto',
                        'isOnlyChildPhoto',
                        'isSoldierChildPhoto',
                        'addressPhotoPhoto',
                        'propertyPhotoPhoto',
                        'isSingleParentPhoto',
                        'isMajorDisPhoto',
                        // 'isBigBoyPhoto',
                        'propertyNaProvePhoto',
                        'otherCertificatePhoto'
                    ];
                    stuBasicPic.forEach(picItem => {
                        picItem.fileUrl = picItem.photoUrl;
                        if (answerList[propMapping[picItem.itemType]]) {
                            answerList[propMapping[picItem.itemType]].push(picItem);
                        } else {
                            answerList[propMapping[picItem.itemType]] = [picItem];
                        }
                    })
                }
                if (sourceData.stuPropertyList && sourceData.stuPropertyList[0] && sourceData.stuPropertyList[0].propertyRatio) {
                    this.propertyRatioList = JSON.parse(sourceData.stuPropertyList[0].propertyRatio)
                }
                
                console.log(sourceData)
                this.answerList = Object.assign({}, this.answerList, answerList);
                if (this.answerList.stuPropertyList && this.answerList.stuPropertyList[0] && this.answerList.stuPropertyList[0].isLive == 0) {
                    this.answerList.stuPropertyList[0].isLive = 2;
                }
                if(this.answerList.isTeachAreaStu==0){
                    this.answerList.isTeachAreaStu=1
                }
                 this.answerList.isBigBoy = sourceData.isBigBoy==1;
                if (this.hasName('houseDetailsPhotos')) {
                    if (this.answerList.stuPropertyList && this.answerList.stuPropertyList[0]) {
                        if (this.answerList.stuPropertyJson) {
                            const stuProperty = JSON.parse(this.answerList.stuPropertyJson);
                            if (stuProperty.length !== 0 && stuProperty[0].houseDetailsPics) {
                                this.answerList.houseDetailsPics = stuProperty[0].houseDetailsPics;
                            }
                        } else if (this.answerList.stuPropertyList[0].houseDetailsPics) {
                            this.answerList.houseDetailsPics = JSON.parse(this.answerList.stuPropertyList[0].houseDetailsPics);
                        }
                    }
                }

            },
            packData() {
                const relationMapping = ['', '父母', '祖父母', '外祖父母', '其他'];

                const args = {};
                let stuBasicPic = [];
                let stuPropertyListObj = {};
                this.fieldNameList.forEach(item => {
                    if ([
                        'stuName',
                        'birthday',
                        'idCard',
                        'graduateSchool',
                        'graduateClass',
                        'nativePlace',
                        'interests',
                        'familyJyln',
                        'childJynYdsm',
                        'childZxhHdxm',
                        'birthCertificateNo',
                        'nodeType',
                        'isTeachAreaStu'
                    ].indexOf(item) !== -1) {
                        args[item] = this.answerList[item];
                    } else if (item === 'weight') {
                        args.weightCode = this.answerList.weight;
                        args.weight = this.weightList.find(item => item.code === this.answerList.weight).value;
                    } else if (item === "stature") {
                        args.statureCode = this.answerList.stature;
                        args.stature = this.statureList.find(item => item.code === this.answerList.stature).value;
                    } else if ([
                        'birthProve',
                        'vaccinateProve',
                        'isSoldierChild',
                        // 'isBigBoy',
                        'childPhoto',
                        'isSingleParent',
                    ].indexOf(item) !== -1) {
                        args[item] = this.answerList[item] ? 1 : 2;
                        stuBasicPic = [...stuBasicPic, ...this.answerList[`${item}Photo`]];
                    } else if(item == 'isOnlyChild') {
                        if(this.answerList.isSingleton) {
                            args[item] = this.answerList[item] ? 1 : 2;
                            stuBasicPic = [...stuBasicPic, ...this.answerList[`${item}Photo`]];
                        } else {
                            args[item] = 2;
                        }
                    } else if ([
                        'addressPhoto',
                        'propertyPhoto',
                        'otherCertificate'
                    ].indexOf(item) !== -1) {
                        stuBasicPic = [...stuBasicPic, ...this.answerList[`${item}Photo`]];
                    } else if (item === 'homeCity') {
                        const homeAddress = this.answerList['homeAddress'];
                        args.homeProvCode = homeAddress[0];
                        args.homeProvName = CodeToText[homeAddress[0]];
                        args.homeCityCode = homeAddress[1];
                        args.homeCityName = CodeToText[homeAddress[1]];
                        args.homeCountyCode = homeAddress[2];
                        args.homeCountyName = CodeToText[homeAddress[2]];
                        args.homeAddress = this.answerList['homeAddressDetail'];
                    } else if (item === 'birthSite') {
                        const birthAddress = this.answerList['birthAddress'];
                        args.birthProvCode = birthAddress[0];
                        args.birthProvName = CodeToText[birthAddress[0]];
                        args.birthCityCode = birthAddress[1];
                        args.birthCityName = CodeToText[birthAddress[1]];
                        args.birthCountyCode = birthAddress[2];
                        args.birthCountyName = CodeToText[birthAddress[2]];
                        args.birthAddress = this.answerList['birthAddressDetail'];
                    } else if ([
                        'houseHolder',
                        'holderRelation',
                        'propertyNo',
                        'propertyHolder',
                        'propertyRelation',
                        'isLive',
                        'propertyArea',
                        'qiuNo',
                        'sectionNo',
                    ].indexOf(item) !== -1) {
                        stuPropertyListObj[item] = this.answerList.stuPropertyList[0][item];
                    } else if ([
                        'settleTime',
                        'propertyTime',
                    ].indexOf(item) !== -1) {
                        stuPropertyListObj[item] = moment(this.answerList.stuPropertyList[0][item]).format('YYYY-MM-DD');
                    } else if (item === 'accAddress') {
                        if (this.hasName('accAddressFill')) {
                            stuPropertyListObj[item] = this.answerList.stuPropertyList[0][item];
                            const homeAddress = this.answerList.stuPropertyList[0]['accAddressFillCode'];
                            stuPropertyListObj.accProvCode = homeAddress[0];
                            stuPropertyListObj.accProvName = CodeToText[homeAddress[0]];
                            stuPropertyListObj.accCityCode = homeAddress[1];
                            stuPropertyListObj.accCityName = CodeToText[homeAddress[1]];
                            stuPropertyListObj.accCountyCode = homeAddress[2];
                            stuPropertyListObj.accCountyName = CodeToText[homeAddress[2]];
                        } else {
                            stuPropertyListObj[`${item}Code`] = this.answerList.stuPropertyList[0][item];

                            if (this.answerList.stuPropertyList[0].accAddress != 0) {
                                stuPropertyListObj[item] = this.teachAreaList.find(({code}) => this.answerList.stuPropertyList[0][item] === code).value;

                                if (this.subTeachAreaList1.length !== 0) {
                                    stuPropertyListObj.accDetAddressCode = this.answerList.stuPropertyList[0].accDetAddress;
                                    stuPropertyListObj.accDetAddress = this.subTeachAreaList1.find(({code}) => this.answerList.stuPropertyList[0].accDetAddress === code).value;
                                } else {
                                    stuPropertyListObj.accDetAddressCode = 0;
                                    stuPropertyListObj.accDetAddress = '';
                                }
                            } else {
                                stuPropertyListObj[item] = '';
                                stuPropertyListObj.accDetAddressCode = 0;
                                stuPropertyListObj.accDetAddress = this.answerList.stuPropertyList[0].accDetAddress;
                            }
                            if (this.answerList.stuPropertyList[0].accAddress != 9999) {
                                let accDetSupplement = '';
                                if (this.accDepartHelper[0]) {
                                    accDetSupplement += `${this.accDepartHelper[0]}`;
                                }
                                // if (this.accDepartHelper[1]) {
                                //     accDetSupplement += `${this.accDepartHelper[1]}单元`;
                                // }
                                // accDetSupplement += `${this.accDepartHelper[2]}室`;
                                stuPropertyListObj.accDetHelpStr = this.accDepartHelper.join(',');
                                stuPropertyListObj.accDetSupplement = accDetSupplement;
                            } else {
                                stuPropertyListObj.accDetHelpStr = '';
                                stuPropertyListObj.accDetSupplement = this.answerList.stuPropertyList[0].accDetSupplement;
                            }

                        }
                    } else if (item === 'propertyAddress') {
                        if (this.hasName('propertyAddressFill')) {
                            stuPropertyListObj[item] = this.answerList.stuPropertyList[0][item];
                        } else {
                            stuPropertyListObj[`${item}Code`] = this.answerList.stuPropertyList[0][item];
                            if (this.answerList.stuPropertyList[0].propertyAddress != 0) {
                                stuPropertyListObj[item] = this.teachAreaList.find(({code}) => this.answerList.stuPropertyList[0][item] === code).value;

                                if (this.subTeachAreaList2.length !== 0) {
                                    stuPropertyListObj.propertyDetAddressCode = this.answerList.stuPropertyList[0].propertyDetAddress;
                                    stuPropertyListObj.propertyDetAddress = this.subTeachAreaList2.find(({code}) => this.answerList.stuPropertyList[0].propertyDetAddress === code).value;
                                } else {
                                    stuPropertyListObj.propertyDetAddressCode = 0;
                                    stuPropertyListObj.propertyDetAddress = '';
                                }
                            } else {
                                stuPropertyListObj[item] = '';
                                stuPropertyListObj.propertyDetAddressCode = 0;
                                stuPropertyListObj.propertyDetAddress = this.answerList.stuPropertyList[0].propertyDetAddress;
                            }
                            stuPropertyListObj.propertyDetSupplement = this.answerList.stuPropertyList[0].propertyDetSupplement;
                        }
                    } else if (item === 'nation') {
                        args.nationCode = this.answerList.nation;
                        args.nation = this.nationList.find(({code}) => code === this.answerList.nation).value;
                    } else if (item === 'propertyType') {
                        stuPropertyListObj.propertyTypeCode = this.answerList.stuPropertyList[0].propertyType;
                        stuPropertyListObj.propertyTypeName = this.propertyTypeList.find(({code}) => code === this.answerList.stuPropertyList[0].propertyType).value;
                    } else if (item === 'isMajorDis') {
                        args.isMajorDis = this.answerList.isMajorDis ? 1 : 2;
                        args.majorDisRemark = this.answerList.majorDisRemark;
                        if (this.answerList.isMajorDis) {
                            stuBasicPic = [...stuBasicPic, ...this.answerList[`isMajorDisPhoto`]];
                        }
                    } else if (item === 'isSingleton') {
                        args.isSingleton = this.answerList.isSingleton ? 1 : 2;
                    } else if (item === 'propertyRatio') {
                        if (8 == this.answerList.stuPropertyList[0].propertyRelation) {
                            stuPropertyListObj.propertyRatio = JSON.stringify(this.propertyRatioList);
                        } else {
                            stuPropertyListObj.propertyRatio = '';
                        }
                    } else if (item === 'propertyTypeRemark') {
                        if (109 == this.answerList.stuPropertyList[0].propertyType) {
                            stuPropertyListObj.propertyTypeRemark = this.answerList.stuPropertyList[0].propertyTypeRemark;
                        } else {
                            stuPropertyListObj.propertyTypeRemark = this.answerList.stuPropertyList[0].propertyTypeRemark;
                        }
                    } else if (item === 'propertyNaProve') {
                        if (2 == this.answerList.stuPropertyList[0].propertyRelation) {
                            stuBasicPic = [...stuBasicPic, ...this.answerList[`propertyNaProvePhoto`]];
                        }
                    } else if (item === 'actualAddress') {
                        if (2 === this.answerList.stuPropertyList[0].isLive) {
                            args[item] = this.answerList[item];
                            const homeAddress = this.answerList['actualAddressCode'];
                            args.actualProvCode = homeAddress[0];
                            args.actualProvName = CodeToText[homeAddress[0]];
                            args.actualCityCode = homeAddress[1];
                            args.actualCityName = CodeToText[homeAddress[1]];
                            args.actualCountyCode = homeAddress[2];
                            args.actualCountyName = CodeToText[homeAddress[2]];
                        } else {
                            args[item] = '';
                        }
                    } else if (item === 'liveMembers') {
                        if(1 === this.answerList.stuPropertyList[0].isLive) {
                            stuPropertyListObj[item] = this.answerList.stuPropertyList[0][item];
                        } else {
                            stuPropertyListObj[item] = '';
                        }
                    } else if (item === 'houseDetailsPhotos') {
                        stuPropertyListObj['houseDetailsPics'] = this.answerList.houseDetailsPics;
                    } else if (item === 'healthTravelCode') {
                        args['healthTravelPics'] = this.answerList.healthTravelPics;
                    } else if (item === 'propertyRemark') {
                        stuPropertyListObj[item] = this.answerList.stuPropertyList[0][item];
                    } else if (item === 'withChildRelation') {
                        stuPropertyListObj.withChildRelation = this.answerList.stuPropertyList[0].withChildRelation;
                        stuPropertyListObj.withChildRelationDes = this.answerList.stuPropertyList[0].withChildRelation != 4 ? relationMapping[this.answerList.stuPropertyList[0].withChildRelation] : this.answerList.stuPropertyList[0].withChildRelationDes;
                    }
                });
                args.stuBasicPicJson = stuBasicPic;
                args.stuPropertyJson = [stuPropertyListObj];

                const eduMapping = [
                    '无',
                    '小学',
                    '初中',
                    '中专',
                    '高职',
                    '高中',
                    '大学专科',
                    '大学本科',
                    '研究生/硕士',
                    '研究生/博士',
                    '研究生/博士后'
                ];
                const nickMapping = [
                    '爸爸',
                    '妈妈',
                    '爷爷',
                    '奶奶',
                    '外公',
                    '外婆',
                    '家长',
                ];
                args.stuParentJson = this.answerList.parentsInfo.filter(item => !!item.parentName);
                args.stuParentJson.forEach(item => {
                    item.education = eduMapping[item.eduVal];
                    const dutyTypeObj = this.dutyTypeList.find(({code}) => code === item.dutyTypeCode);
                    item.dutyTypeName = dutyTypeObj ? dutyTypeObj.value : '';
                    item.nickName = nickMapping[item.nickCode];
                    if (this.hasName('residenceAddress')) {
                        const homeAddress = item['residence'];
                        item.resProvCode = homeAddress[0];
                        item.resProvName = CodeToText[homeAddress[0]];
                        item.resCityCode = homeAddress[1];
                        item.resCityName = CodeToText[homeAddress[1]];
                        item.resCountyCode = homeAddress[2];
                        item.resCountyName = CodeToText[homeAddress[2]];
                    }
                });
                if (this.answerList.parentsInfo[0].phone) {
                    args.fatherPhone = this.answerList.parentsInfo[0].phone;
                }
                if (this.answerList.parentsInfo[1].phone) {
                    args.matherPhone = this.answerList.parentsInfo[1].phone;
                }
                args.loginPhone = this.loginPhone;
                console.log(args);
                return args;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../styles/mixin";

    @include globalstyle;

    .section__title {
        padding-top: 20px !important;
    }

    .page {
        padding: 20px;
    }

    .table-container {
        padding: 20px;
    }

    .main-container {
        font-family: "microsoft yahei";
        color: #717171;
        width: 1310px;
        margin: 10px auto;
        position: relative;
        z-index: 1000;
    }

    .header {
        width: 1100px;
        padding: 10px auto;
        box-sizing: border-box;
        position: relative;
        z-index: 1000;
        margin: 0 auto;
    }

    .questionnaire-container--detail {
        padding: 20px;
    }

    .section {
        background-color: #fff;
        padding-bottom: 20px;
        margin: 20px 0;
        border-radius: 5px;

        .section__title {
            font-size: 24px;
        }

        @include clearfix;
    }

    .questionnaire-container {
        width: 1100px;
        margin: 0 auto;
        box-sizing: border-box;

        input[type=text], textarea {
            &:focus {
                background: #FDF9CD;
            }
        }

        .questionnaire-title {
            padding: 5px 50px;

            input, textarea {
                width: 100%;
                height: 100%;
                text-align: center;
                font-size: 20px;
                border: 0;
                resize: none;
            }
        }

        .address-book-container {
            width: 200px;
            display: inline-block;
            vertical-align: middle;
        }

        .questionnaire-title {
            font-size: 20px;
            height: 56px;
            text-align: center;
            line-height: 56px;
        }

        .questionnaire-desc {
            height: 90px;
            font-size: 18px;
        }

        .operation-icon {
            display: none;
            /*display: inline-block;*/
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background-image: url(../../../assets/images/wjsj_toolico_off.png);
            background-repeat: no-repeat;
            cursor: pointer;
        }

        .student-info-item {
            margin-bottom: 10px;
            clear: both;
        }

        .base-info {
            float: left;
        }

        .base-info:nth-child(1),
        .base-info:nth-child(2) {
            width: 20%;
        }

        .base-info:nth-child(3),
        .base-info:nth-child(4) {
            width: 30%;
        }

        .question-container {
            color: #000;

            .question-item__body {
                margin-top: 10px;
                @include clearfix;
            }

            .question-item__left {
                text-align: center;
                width: 50px;
                float: left;

            }

            .question-item__right {
                float: left;
                width: 100%;
                box-sizing: border-box;
                padding: 0 20px;

                .question-item__title {

                    margin-top: 20px;
                    font-size: 16px;
                    font-weight: bold;

                    input {
                        width: 72%;
                    }
                }

                .question-choice-options {
                    height: 26px;
                }

                input, textarea {
                    width: 100%;
                    height: 100%;
                    font-size: 14px;
                    border: 0;
                    resize: none;
                    margin-bottom: 5px;

                    &:focus {
                        background: #FDF9CD;
                    }
                }

                .option-del-icon {
                    margin-left: 5px;
                    background-position: -122px -241px;

                    &.option-del-icon--show {
                        display: inline-block !important;
                    }
                }

                .add-choice-icon {
                    margin-left: 20px;
                    background-position: -20px -200px;
                }

                .batch-add-choice-icon {
                    margin-left: 10px;
                    background-position: -20px -220px;
                }

            }

            .question-item {
                @include clearfix;
                float: left;
                width: 49%;

                &.question-item--pic, &.question-item--wide {
                    box-sizing: border-box;
                    width: 100%;
                }

                &.question-item--pic {
                    padding-left: 4em;
                    color: #565656 !important;
                }

            }
        }

        .quetion-item--pic-single-choice,
        .quetion-item--pic-multiple-choice,
        .quetion-item--pic-single-uploader,
        .quetion-item--pic-multiple-uploader {
            .question-option-container {
                width: 130px;
                float: left;
                border: 1px solid #ccc;
                margin-right: 10px;
                margin-bottom: 10px;
                padding: 5px;

                .question-pic {
                    width: 130px;
                    height: 130px;
                    display: block;
                    margin-bottom: 5px;
                    @include cover-bg;
                }

                .question-pic-desc {
                    span {
                        @include middleIB;
                        width: 70%;
                    }

                    input {
                        width: 75% !important;
                    }
                }
            }
        }
    }

    .upload-hint {
        width: 130px;
        height: 130px;
        float: left;
        border: 1px solid #ccc;
        margin-right: 10px;
        margin-bottom: 10px;
        background: url(../../../assets/images/picinput.png) no-repeat;
        background-position: center center;
        cursor: pointer;
    }

    input.blank {
        border-width: 0;
        border-bottom: 1px solid #000 !important;
    }

    .dialog-button-container {
        margin-top: 10px;
        text-align: right;
    }

    .question-option-container {
        margin-top: 10px;
    }

    .divider {
        border: 1px solid #999;
    }

    .pic-example {
        float: left;
        text-align: center;
    }

    .pic-example-container {
        @include middleIB;
    }

    .pic-example--pic {
        @include cover-bg;
        @include wh(20px, 20px);
        border: 1px solid #ccc;
        position: relative;
        @include middleIB;
    }

    .pic-item {
        @include cover-bg;
        @include wh(130px, 130px);
        border: 1px solid #ccc;
        float: left;
        margin: 0 10px 10px 0;
        position: relative;

        .delete-icon {
            cursor: pointer;
            background-image: url(../../../assets/images/wxcep_phone_close.png);
            z-index: 1000;
            position: absolute;
            right: 0;
            top: 0;
            @include wh(30px, 30px);
            background-size: cover;
        }
    }

    .color-block {
        margin-left: 20px;
        @include wh(16px, 16px);
        @include middleIB;
        background-color: #20a0ff;
        margin-right: 5px;
    }

    .table-container {
        table {
            border-collapse: collapse;
        }

        td, th {
            border: 1px solid #000;
        }
    }


    .page {
        height: 100%;
    }

    .confirm-part {
        margin: 10px 0 10px 9px;
    }

    .confirm-part--text {
        text-indent: 2em;
        color: #999;
        line-height: 1.5em;
        letter-spacing: 0.1em;
    }

    .red-star {
        color: #ff0000;
    }

    .bg {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: no-repeat url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/pc-primary-fillblank-bg.jpg) center top / 100% auto;
    }

    .fill-hint {
        text-align: right;
        width: 9em;
        @include middleIB;
        color: #565656;
    }

    .item-hint {
        margin: 5px 0;
        color: #666;
        font-size: 14px;
    }

    .info-text {
        color: #999;
    }

    .title-icon {
        @include wh(30px, 30px);
        @include cover-bg;
        @include middleIB;
        margin-right: 5px;

        &.title-icon--base {
            background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/information.png);
        }

        &.title-icon--misc {
            background-image: url(https://cdnfile-10043692.file.myqcloud.com/schoolSignup/personal%20information.png);
        }
    }

    .request-hint {
        color: red;
    }

    .sub-textarea-container {
        box-sizing: border-box;
        padding-left: 132px;
        margin-top: 10px;
    }

    .textarea-container {
        display: inline-block;
        vertical-align: top;
        width: 890px;
    }

    .question-item__title--general {
        margin-left: -4em;
    }

    .ratio-item {
        margin-top: 5px;
        font-weight: normal;

        .ratio-item__part {
            @include middleIB;
        }

        span {
            @include middleIB;
        }
    }
</style>
<style lang="scss">
    #questionnaire {
        background-color: #f8f8f8;

        .address-box-item {
            line-height: 36px;
        }

        .el-checkbox, .el-checkbox__input {
            white-space: normal !important;
        }

        .el-checkbox {
            color: #565656 !important;
        }

        .file-name {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/outer/OuterQuestionnaire.vue